var exports = {
  "JC": "Accordion.module__accordion___dzE0T1",
  "U1": "Accordion.module__headerRow___dzE0T1",
  "L9": "Accordion.module__headerClickTarget___dzE0T1",
  "N4": "Accordion.module__titleButton___dzE0T1",
  "Z2": "Accordion.module__descriptionButton___dzE0T1",
  "me": "Accordion.module__caretButton___dzE0T1",
  "VW": "Accordion.module__headerContent___dzE0T1",
  "$": "Accordion.module__titleRow___dzE0T1",
  "QE": "Accordion.module__headerAction___dzE0T1",
  "ID": "Accordion.module__compactTitle___dzE0T1",
  "SY": "Accordion.module__compactDescription___dzE0T1",
  "OW": "Accordion.module__caret___dzE0T1",
  "bd": "Accordion.module__caretExpanded___dzE0T1",
  "FG": "Accordion.module__contentWrapper___dzE0T1",
  "Qs": "Accordion.module__content___dzE0T1",
};

module.exports = exports;
